/**
 * Grid helper
 * 
 * @param {*} param0 
 * @returns 
 */
const Floor = ({ color }) => <gridHelper args={[10000, 400, 'black', color]} position={[0,0,0]} />;

export default Floor;